import React, { useState, useCallback } from "react";
import { toastr } from "react-redux-toastr";
import { useDropzone } from "react-dropzone";
import { S3ClientForUserApplications } from "../../../utils/s3Config";

function SampleMinistryPaper(props) {
  const { removeFile, updateForm, sampleMinistryPaper, isSampleMinistryPaperImage } = props;

  const [state, setState] = useState({
    samplePaperLoader: false,
  });

  const onDrop = useCallback((acceptedFiles) => {
    setState({ ...state, samplePaperLoader: true });
    if (acceptedFiles && acceptedFiles.length > 0) {
      let file = acceptedFiles[0];
      if (file.length === 0) {
        toastr.error("Error", "Please upload correct file");
        return;
      }
      if (file.size > 5000000) {
        toastr.error("Error", "Please upload file less than 5MB");
        return;
      }

      S3ClientForUserApplications.uploadFile(file, new Date().getTime())
        .then((data) => {
          updateForm(
            "sampleMinistryPaper",
            data && data.location ? data.location : null
          );
          state.isSampleMinistryPaperImage =
            file.type == "image/jpeg" || file.type == "image/png";
          state.statementFileName = file.name || "File";
          setState({ ...state, samplePaperLoader: false });
        })
        .catch((err) => {
          toastr.error("Error", "Sample Ministry Paper Uploading Fail");
          setState({ ...state, samplePaperLoader: false });
        });
    } else {
      setState({ ...state, samplePaperLoader: false });
      toastr.error("Error", "Invalid File Type. PDF only");
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".pdf",
  });

  return (
    <>
      <div className='sub-heading app-info'>Sample Ministry Paper (Required)</div>
      <div className='field-label'>
        Please submit an appropriate sample ministry paper (sermon, study guide, reflection, educational resources) less than 15 pages that is representative of your work and related to the area of interest.
      </div>
      {state.samplePaperLoader && (
        <img
          src={`/icons/loading.svg`}
          style={{
            height: "25px",
            marginLeft: "10px",
            backgroundColor: "#000",
          }}
        />
      )}
      <div className='input-group'>
        <div className='drag-block'>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drag & Drop a File or Click to Choose</p>
            ) : (
              <p>Drag & Drop a File or Click to Choose</p>
            )}
          </div>
        </div>
        {sampleMinistryPaper && (
          <ul className='multi-images'>
            <li>
              <span>
                {isSampleMinistryPaperImage ? (
                  <img src={sampleMinistryPaper} alt='Statement of Focus' />
                ) : (
                  <img className='doc-icon' src='/icons/file-icon.svg' />
                )}
                <div className='thumb_overlay'>
                  <div
                    className='thumb_cross'
                    onClick={() => removeFile("sampleMinistryPaper")}
                  >
                    ✕
                  </div>
                </div>
              </span>
            </li>
          </ul>
        )}
      </div>
      {sampleMinistryPaper === false && (
        <div className='field-error'>Must add Sample Ministry Paper</div>
      )}
    </>
  );
}

export default SampleMinistryPaper;
